var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"public-link no-outline badge badge--medium",class:{
		'has-border': _vm.hasBorder,
		'disabled': _vm.disabled,
	},attrs:{"tabindex":"0"}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }